module.exports = __webpack_public_path__ + "static/media/interact-logo.5bd3bc52.svg";